/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, June 4th 2022, 4:32:13 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmptyStateActionWrapper, Image } from "ui-widgets";
import Typography from "@mui/material/Typography";
import { ADMIN_DOCUMENTATION_URL } from "config";
import { useServiceBuilderContext } from "service-builder/providers";
import { ProcessDefinitionLinkTeamButton } from "./ProcessDefinitionLinkTeam";

export const EmptyServiceTeamsCTA = () => {
  const {
    processDefinitionContext: { currentProcessDefinition },
  } = useServiceBuilderContext();

  return (
    <EmptyStateActionWrapper
      title={
        <>
          No Teams are linked to <b>{currentProcessDefinition.title}</b>.
        </>
      }
      description={
        <Typography>
          You must link at least one team to this service for workers to access it in the staff portal. Only workers
          belonging to selected teams will be able to view and/or process submissions for this service. Onestop further
          gives you the ability to dictate which teams can execute, assign or supervise workflow tasks for a submission
          by choosing a team for each configured user task that is not a client task. Read our{" "}
          <a target="_blank" href={ADMIN_DOCUMENTATION_URL} rel="noreferrer">
            online documentation here
          </a>{" "}
          for more information
        </Typography>
      }
      illustrationGraphic={<Image className="image-style-A" src="/img/teamwork.png" alt="Onestop Admin" />}
    >
      <ProcessDefinitionLinkTeamButton size="large" />
    </EmptyStateActionWrapper>
  );
};
